import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";
 
export class CTRL_527 implements Validator { 
 
    public static id = 'CTRL_527'; 
    private message = 'error.ctr_527'; //message d’erreur en dur, à terme dans un JSON FR ou EN 
 
 
 
 
    validate(form: any, map) { 
 
 
        // vérifier si la règle est applicable sur mon formulaire 
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_527.id); 
 
 
        if (rgs.length > 0) { 
            for (var rg of rgs) { 
                const ctrl = form.controls[rg];
			//ajout du STEP_ID sur le champ 
                const nbMoisWithStepId = map.get(ctrl.value.rgCtrls.nbMois); 
                const nbJoursWithStepId = map.get(ctrl.value.rgCtrls.nbJours); 
                const dateACompterDuWithStepId = map.get(ctrl.value.rgCtrls.dateACompterDu);
                const dateJusquauWithStepId = map.get(ctrl.value.rgCtrls.dateJusquau);
                const nbMois = form.controls[nbMoisWithStepId]; 
                const nbJours = form.controls[nbJoursWithStepId]; 
                const dateACompterDu = form.controls[dateACompterDuWithStepId];
                const dateJusquau = form.controls[dateJusquauWithStepId];
                if ((this.isPattern(nbMois.value) && (this.isPattern(dateACompterDu.value) || this.isPattern(dateJusquau.value)))
                || (this.isPattern(nbJours.value) && (this.isPattern(dateACompterDu.value) || this.isPattern(dateJusquau.value)))
                || (this.isPattern(nbMois.value) && this.isPattern(nbJours.value))) { 
                    // placer le message d'erreur 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message }; 
                } else { 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false }; 
                } 
            } 
        } 
    } 

    isPattern(value): boolean{
        return (value !== undefined && value !== null && value !== '' && value !== 0 && value !== "yyyy-MM-dd");
    }
} 
 
